import React, { useContext, useEffect, useState } from "react";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import {
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  PageDesignConstants,
  RRMMCohortTreatment,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";

import ErrorField from "../../Components/ErrorField";
import { CommonError_Msgs } from "../../Helpers/HelperText";
import { AppContext } from "../../Contexts/AppContextProvider";
import {
  validateRadiotherapyDate,
  GetLocalStorageData,
  GetLoggedInUserID,
  isStringEmpty,
  isStringEmptyDh,
  IsAdmin,
  useCollapsibleGroups,
  CollapsibleSectionHeader,
} from "../../Helpers/Utilities";
import { DiseaseHistErrorMsg } from "../../Helpers/HelperText";
import { DiseaseHistoryService } from "../../WebApiServices/DiseaseHistory.service";
import DatePickerComponent from "../../Components/DatePickerComponent";
import dayjs from "dayjs";
import { Collapse } from "react-bootstrap";

const DiseaseHistory = () => {
  const navigatePaths = {
    prevPage: "/Demographics",
    currPage: "/DiseaseHistory",
    nextPage: "/Comorbidities",
  };

  const pid = GetLocalStorageData("patientId") ?? 0;

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
  } = useContext(AppContext);

  const [diseaseHist, setDiseaseHist] = useState({
    userId: GetLoggedInUserID(),
    q11_Percentage: null,
    q11_Percentage_txt: "",

    diseaseHistoryId: 0,

    q12_1: null,
    q12_1_sub: null,
    q12_2: null,
    q12_3: null,
    q12_4: null,
    q12_5: null,
    q12_6: null,
    q12_7: null,
    q12_8: null,
    q12_8_sub: null,

    q16_1: null,
    q16_2: null,
    q16_3: null,
    q16_4: null,
    q16_5: null,
    q16_6: null,
    q16_7: null,
  });

  const RepeaterRow = {
    cohortTreatmentId: 0,
    diseasehistorytreatmentId: 0,
    diseaseHistoryId: 0,

    cohortIndexDate: "",
    earliestCohortIndexDate: "",
    cohortIndexDateMin91: "",
    cohortIndexDatePlus30: "",
    cohortIndexDateMinusDays: "",
    cohortTreatmentNameSuperscript: "",
    cohortTreatmentName: "",

    q12_9: null,
    q12_9_hard_Err: false,

    q12_10: null,
    q12_10_hard_Err: false,

    q13: null,
    q13_hard_Err: false,

    q14: null,
    q14_hard_Err: false,

    q15: null,
    q15_1: null,
    q15_2: null,

    q15_hard_Err: false,
    q15_1_hard_Err: false,
    q15_1_date: "",
    q15_1_default_date: null,

    q15_2_date: null,
    q15_2_default_date: null,
    q15_2_hard_Err: false,
    q15_2_default_date: null,

    q15_1_date_Err: false,
    q15_2_date_Err: false,
    q15_1_DateInvalid: false,
    q15_2_DateInvalid: false,

    q15_1_date_Empty_Err: false,
    q15_2_date_Empty_Err: false,

    q15_2_date_Greater_Error: false,

    q17_5: null,
    q17_5_hard_Err: false,

    q17_6: null,
    q17_6_hard_Err: false,

    q17_1: null,
    q17_1_hard_Err: false,
    q17_2: null,
    q17_2_hard_Err: false,
    q17_3: null,
    q17_3_hard_Err: false,
    q17_4: null,
    q17_4_hard_Err: false,
    ndmm: false,
  };

  const [repeaterDiseaseHist, setRepeaterDiseaseHist] = useState([RepeaterRow]);
  // Q13-Q15.2 only: one row per NDMM cohort / Bispecific-CAR-T LOT cohort (Line_CohortID).
  // Everything else on the page keeps using repeaterDiseaseHist (one row per drug).
  const [lotRows, setLotRows] = useState([]);

  const [shouldRenderDiv, setShouldRenderDiv] = useState(false);

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const [isNewEcrfA, setIsNewEcrfA] = useState(false);
  const [isNewEcrfC, setIsNewEcrfC] = useState(false);
  // expand/collapse state of each Q13-Q15 cohort / LOT block, keyed by index
  const { isCollapsed: isDhBlockCollapsed, toggleGroup: toggleDhBlock } =
    useCollapsibleGroups();
  // expand/collapse state of each Q12.9.A-Q12.10.A cohort block, keyed by index
  const { isCollapsed: isDhABlockCollapsed, toggleGroup: toggleDhABlock } =
    useCollapsibleGroups();
  // separate expand/collapse state for the Q17 blocks (same indexes as lotRows)
  const { isCollapsed: isQ17BlockCollapsed, toggleGroup: toggleQ17Block } =
    useCollapsibleGroups();

  //HARD ERRORS STATE
  const InitialHardErrList = {
    q11_hard_err: false,
    q11_Percentage_Empty: false,

    q12_1_hard_err: false,
    q12_1_sub_hard_err: false,
    q12_2_hard_err: false,
    q12_3_hard_err: false,
    q12_4_hard_err: false,
    q12_5_hard_err: false,
    q12_6_hard_err: false,
    q12_7_hard_err: false,
    q12_8_hard_err: false,
    q12_8_sub_hard_err: false,

    q16_1_hard_err: false,
    q16_2_hard_err: false,
    q16_3_hard_err: false,
    q16_4_hard_err: false,
    q16_5_hard_err: false,
    q16_6_hard_err: false,
    q16_7_hard_err: false,
  };
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);

  const bispecificDiseaseAssessmentCohortIds = [
    RRMMCohortTreatment.TECVAYLI,
    RRMMCohortTreatment.TALVEY,
    RRMMCohortTreatment.ELREXFIO,
    RRMMCohortTreatment.Linvoseltamab,
  ];

  const isBispecificDiseaseAssessmentCohort = (cohortTreatmentId) =>
    bispecificDiseaseAssessmentCohortIds.includes(Number(cohortTreatmentId));

  // Q17.1-Q17.4 shows once per qualifying cohort: every NDMM cohort, plus (when Element C
  // is enabled for the center) every bispecific cohort (Tec/Tal/Elran/Linvo) - a patient can
  // qualify for more than one at once, so this is evaluated per repeaterDiseaseHist row rather
  // than resolving a single "the" cohort.
  const isDiseaseAssessmentResultsCohort = (rowData, elementCEnabled) =>
    !!rowData?.ndmm ||
    (elementCEnabled &&
      isBispecificDiseaseAssessmentCohort(rowData?.cohortTreatmentId));

  /* <summary>
  date: 12-07-2024
  Name: VK
  description: List of mapping Data
  <summary>*/
  //const [loopState, setLoopState] = useState([]);

  const HandleFieldChange = (e) => {
    const { name, value, checked } = e.target;

    switch (name) {
      //QUESTION 11

      case "q11_Percentage_txt": {
        const newValue =
          value === 0 || value === "0" ? "0" : (value || "").toString().trim();

        setDiseaseHist((prev) => ({
          ...prev,
          q11_Percentage: newValue !== "" ? 1 : null,
          [name]: newValue,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q11_Percentage_Empty: false,
          q11_hard_err: false,
        }));

        break;
      }

      case "q11_Percentage": {
        setDiseaseHist((prev) => ({
          ...prev,
          q11_Percentage: Number(value),
          q11_Percentage_txt: "",
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q11_hard_err: false,
          q11_Percentage_Empty: false,
        }));

        break;
      }

      // QUESTION 12
      case "q12_1": {
        const shouldShowSubQuestion =
          parseInt(value) === 1 && diseaseHist.q11_Percentage === 1; //&&
        // parseFloat(diseaseHist.q11_Percentage_txt) > 20;

        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
          q12_1_sub: shouldShowSubQuestion ? prev.q12_1_sub : null,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_1_hard_err: false,
          q12_1_sub_hard_err: false,
        }));
        break;
      }

      case "q12_1_sub": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_1_sub_hard_err: false,
        }));
        break;
      }

      case "q12_2": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_2_hard_err: false,
        }));
        break;
      }

      case "q12_3": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_3_hard_err: false,
        }));
        break;
      }

      case "q12_4": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_4_hard_err: false,
        }));
        break;
      }

      case "q12_5": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_5_hard_err: false,
        }));
        break;
      }

      case "q12_6": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_6_hard_err: false,
        }));
        break;
      }

      case "q12_7": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_7_hard_err: false,
        }));
        break;
      }

      case "q12_8": {
        const shouldShowSubQuestion = parseInt(value) === 1;
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
          q12_8_sub: shouldShowSubQuestion ? prev.q12_8_sub : null,
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_8_hard_err: false,
          q12_8_sub_hard_err: false,
        }));
        break;
      }

      case "q12_8_sub": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_8_sub_hard_err: false,
        }));
        break;
      }

      case "q12_9": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_9_hard_err: false,
        }));
        break;
      }

      case "q12_10": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q12_10_hard_err: false,
        }));
        break;
      }

      //QUESTION 16
      case "q16_1": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q16_1_hard_err: false,
        }));
        break;
      }

      case "q16_2": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q16_2_hard_err: false,
        }));
        break;
      }

      case "q16_3": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q16_3_hard_err: false,
        }));
        break;
      }

      case "q16_4": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q16_4_hard_err: false,
        }));
        break;
      }

      case "q16_5": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q16_5_hard_err: false,
        }));
        break;
      }

      case "q16_6": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q16_6_hard_err: false,
        }));
        break;
      }

      case "q16_7": {
        setDiseaseHist((prev) => ({
          ...prev,
          [name]: parseInt(value),
        }));

        setHardErrList((prev) => ({
          ...prev,
          q16_7_hard_err: false,
        }));
        break;
      }

      // Question 17.1-17.4 now render once per qualifying cohort (NDMM and/or bispecific)
      // via repeaterDiseaseHist and are handled in HandleRepeaterFieldChange instead.
      default:
        break;
    }
  };

  const HandleRepeaterFieldChange = (e) => {
    const { name, id, value } = e.target;
    const value_int = Number(value);

    // Extract loopIndex from the name, which ends with the cohort index.
    const loopIndexMatch = String(name).match(/_(\d+)$/);
    const loopIndex = loopIndexMatch ? Number(loopIndexMatch[1]) : NaN;

    // Create a copy of the current state
    let updatedArray = [...repeaterDiseaseHist];

    switch (name) {
      case `q12_9_${loopIndex}`: {
        updatedArray[loopIndex].q12_9 = value_int;
        updatedArray[loopIndex].q12_9_hard_Err = false;
        break;
      }

      case `q12_10_${loopIndex}`: {
        updatedArray[loopIndex].q12_10 = value_int;
        updatedArray[loopIndex].q12_10_hard_Err = false;
        break;
      }

      case `q13_${loopIndex}`: {
        updatedArray[loopIndex].q13 = value_int;
        updatedArray[loopIndex].q13_hard_Err = false;
        break;
      }
      case `q14_${loopIndex}`: {
        updatedArray[loopIndex].q14 = value_int;
        updatedArray[loopIndex].q14_hard_Err = false;
        break;
      }

      case `q15_${loopIndex}`: {
        updatedArray[loopIndex].q15 = value_int;
        updatedArray[loopIndex].q15_hard_Err = false;
        updatedArray[loopIndex].q15_1_date_Empty_Err = false;
        updatedArray[loopIndex].q15_2_date_Empty_Err = false;

        updatedArray[loopIndex].q15_1 = null;

        if (value_int == 2 || value_int == 99) {
          updatedArray[loopIndex].q15_1_date = "";
          updatedArray[loopIndex].q15_2 = null;
          updatedArray[loopIndex].q15_2_date = "";
          updatedArray[loopIndex].q15_1_date_Err = false;
          updatedArray[loopIndex].q15_1_DateInvalid = false;
          updatedArray[loopIndex].q15_2_DateInvalid = false;
          updatedArray[loopIndex].q15_2_date_Err = false;
          updatedArray[loopIndex].q15_2_hard_Err = false;
          updatedArray[loopIndex].q15_1_hard_Err = false;
          updatedArray[loopIndex].q15_1_date_Empty_Err = false;
          updatedArray[loopIndex].q15_2_date_Empty_Err = false;
          updatedArray[loopIndex].q15_2_date_Greater_Error = false;
        }

        break;
      }

      case `q15_1_${loopIndex}`: {
        updatedArray[loopIndex].q15_1 = value_int;
        updatedArray[loopIndex].q15_1_hard_Err = false;
        updatedArray[loopIndex].q15_1_date = "";
        updatedArray[loopIndex].q15_1_date_Err = false;
        updatedArray[loopIndex].q15_1_DateInvalid = false;
        updatedArray[loopIndex].q15_2_DateInvalid = false;

        updatedArray[loopIndex].q15_1_date_Empty_Err = false;
        updatedArray[loopIndex].q15_2_date_Greater_Error = false;

        break;
      }

      case `q15_2_${loopIndex}`: {
        updatedArray[loopIndex].q15_2 = value_int;
        updatedArray[loopIndex].q15_2_hard_Err = false;
        updatedArray[loopIndex].q15_2_date = "";
        updatedArray[loopIndex].q15_2_date_Err = false;
        updatedArray[loopIndex].q15_2_date_Empty_Err = false;
        updatedArray[loopIndex].q15_2_date_Greater_Error = false;

        break;
      }

      // Q17.1-Q17.6 are per LOT cohort - see HandleLotFieldChange

      default:
        break;
    }

    setRepeaterDiseaseHist(updatedArray);
  };

  const HandleRepeaterDateChange = (name, date) => {
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);

    let updatedArray = [...repeaterDiseaseHist];
    let cohortIndexedDate = updatedArray[id].earliestCohortIndexDate;
    let datevalid = validateRadiotherapyDate(date, cohortIndexedDate);

    switch (true) {
      // outpatient Visit Date change
      case name.startsWith("q15_1_date-"):
        updatedArray[id].q15_1_date = updatedArray[id].q15 == 1 ? date : "";
        updatedArray[id].q15_1 = 1;
        updatedArray[id].q15_1_hard_Err = false;
        updatedArray[id].q15_1_date_Err = false;
        updatedArray[id].q15_1_DateInvalid = false;

        // updatedArray[id].q15_1_date_Empty_Err = datevalid ? false : true;
        updatedArray[id].q15_1_date_Empty_Err = false;
        updatedArray[id].q15_2_date_Greater_Error = false;

        break;

      case name.startsWith("q15_2_date-"):
        updatedArray[id].q15_2_date = date;
        updatedArray[id].q15_2 = 1;
        updatedArray[id].q15_2_hard_Err = false;
        updatedArray[id].q15_2_date_Err = false;
        updatedArray[id].q15_2_DateInvalid = false;

        //  updatedArray[id].q15_2_date_Empty_Err = datevalid ? false : true;
        updatedArray[id].q15_2_date_Empty_Err = false;
        updatedArray[id].q15_2_date_Greater_Error = false;

        break;

      default:
        // Handle other cases or do nothing
        return;
    }

    setRepeaterDiseaseHist(updatedArray);
  };

  // Q13-Q15.2 handlers - these work on lotRows (one row per LOT cohort)
  const HandleLotFieldChange = (e) => {
    const { name, value } = e.target;
    const value_int = Number(value);
    const loopIndexMatch = String(name).match(/_(\d+)$/);
    const loopIndex = loopIndexMatch ? Number(loopIndexMatch[1]) : NaN;
    const updatedArray = [...lotRows];
    const row = updatedArray[loopIndex];
    if (!row) return;

    switch (name) {
      case `q12_9_${loopIndex}`:
        row.q12_9 = value_int;
        row.q12_9_hard_Err = false;
        break;

      case `q12_10_${loopIndex}`:
        row.q12_10 = value_int;
        row.q12_10_hard_Err = false;
        break;

      case `q13_${loopIndex}`:
        row.q13 = value_int;
        row.q13_hard_Err = false;
        break;

      case `q14_${loopIndex}`:
        row.q14 = value_int;
        row.q14_hard_Err = false;
        break;

      case `q15_${loopIndex}`:
        row.q15 = value_int;
        row.q15_hard_Err = false;
        row.q15_1_date_Empty_Err = false;
        row.q15_2_date_Empty_Err = false;
        row.q15_1 = null;

        if (value_int == 2 || value_int == 99) {
          row.q15_1_date = "";
          row.q15_2 = null;
          row.q15_2_date = "";
          row.q15_1_date_Err = false;
          row.q15_1_DateInvalid = false;
          row.q15_2_DateInvalid = false;
          row.q15_2_date_Err = false;
          row.q15_2_hard_Err = false;
          row.q15_1_hard_Err = false;
          row.q15_1_date_Empty_Err = false;
          row.q15_2_date_Empty_Err = false;
          row.q15_2_date_Greater_Error = false;
        }
        break;

      case `q15_1_${loopIndex}`:
        row.q15_1 = value_int;
        row.q15_1_hard_Err = false;
        row.q15_1_date = "";
        row.q15_1_date_Err = false;
        row.q15_1_DateInvalid = false;
        row.q15_2_DateInvalid = false;
        row.q15_1_date_Empty_Err = false;
        row.q15_2_date_Greater_Error = false;
        break;

      case `q15_2_${loopIndex}`:
        row.q15_2 = value_int;
        row.q15_2_hard_Err = false;
        row.q15_2_date = "";
        row.q15_2_date_Err = false;
        row.q15_2_date_Empty_Err = false;
        row.q15_2_date_Greater_Error = false;
        break;

      case `q17_1_${loopIndex}`:
      case `q17_2_${loopIndex}`:
      case `q17_3_${loopIndex}`:
      case `q17_4_${loopIndex}`:
      case `q17_6_${loopIndex}`: {
        const key = name.slice(0, name.lastIndexOf("_"));
        row[key] = value_int;
        row[`${key}_hard_Err`] = false;
        break;
      }

      case `q17_5_${loopIndex}`:
        row.q17_5 = value_int;
        row.q17_5_hard_Err = false;

        // Clear Q17.6 if Q17.5 is not "Present" (value 1)
        if (value_int !== 1) {
          row.q17_6 = null;
          row.q17_6_hard_Err = false;
        }
        break;

      default:
        return;
    }

    setLotRows(updatedArray);
  };

  const HandleLotDateChange = (name, date) => {
    const id = name.slice(name.lastIndexOf("-") + 1);
    const updatedArray = [...lotRows];
    const row = updatedArray[id];
    if (!row) return;

    switch (true) {
      case name.startsWith("q15_1_date-"):
        row.q15_1_date = row.q15 == 1 ? date : "";
        row.q15_1 = 1;
        row.q15_1_hard_Err = false;
        row.q15_1_date_Err = false;
        row.q15_1_DateInvalid = false;
        row.q15_1_date_Empty_Err = false;
        row.q15_2_date_Greater_Error = false;
        break;

      case name.startsWith("q15_2_date-"):
        row.q15_2_date = date;
        row.q15_2 = 1;
        row.q15_2_hard_Err = false;
        row.q15_2_date_Err = false;
        row.q15_2_DateInvalid = false;
        row.q15_2_date_Empty_Err = false;
        row.q15_2_date_Greater_Error = false;
        break;

      default:
        return;
    }

    setLotRows(updatedArray);
  };

  function DateInRange(date, minDate, maxDate) {
    return dayjs(date).isAfter(minDate) && dayjs(date).isBefore(maxDate);
  }

  function isValidNumber(value) {
    // Convert value to a number
    const number = parseFloat(value);

    // Check if the value is a number and within the range 0 to 100
    return !isNaN(number) && number >= 0 && number <= 100;
  }

  // Q13-Q15.2 validation, run once per LOT row
  const ValidateLotRows = () => {
    let result = true;
    const updatedLotRows = lotRows.map((row) => {
      let updatedRow = { ...row };

        // Q12.9.A / Q12.10.A (only if isNewEcrfA is true) - answered once per LOT
        if (isNewEcrfA && row.q12_9 === null) {
          updatedRow.q12_9_hard_Err = true;
          result = false;
        } else {
          updatedRow.q12_9_hard_Err = false;
        }
        if (isNewEcrfA && row.q12_10 === null) {
          updatedRow.q12_10_hard_Err = true;
          result = false;
        } else {
          updatedRow.q12_10_hard_Err = false;
        }

        if (row.q13 === null) {
          updatedRow.q13_hard_Err = true;
          result = false;
        } else {
          updatedRow.q13_hard_Err = false;
        }
        if (row.q14 === null) {
          updatedRow.q14_hard_Err = true;
          result = false;
        } else {
          updatedRow.q14_hard_Err = false;
        }

      if (row.q15 === null) {
        updatedRow.q15_hard_Err = true;
        result = false;
      } else if (row.q15 === 2 || row.q15 === 99) {
        updatedRow.q15_1_hard_Err = false;
        updatedRow.q15_2_hard_Err = false;
        updatedRow.q15_hard_Err = false;
      } else {
        updatedRow.q15_hard_Err = false;
      }

      if (row.q15 == 1) {
        if (row.q15_1 == null) {
          updatedRow.q15_1_hard_Err = true;
          result = false;
        } else {
          updatedRow.q15_1_hard_Err = false;
        }

        if (row.q15_1 == 1 && row.q15_1_date == "") {
          updatedRow.q15_1_date_Err = true;
          result = false;
        }

        // if (
        //   row.q15_1 == 1 &&
        //   row.q15_1_date !== "" &&
        //   row.q15_1_date_Empty_Err
        // ) {
        //   updatedRow.q15_1_date_Empty_Err = true;
        //   result = false;
        // }

        //   validateRadiotherapyDate(date, cohortIndexedDate)

        if (
          row.q15_1 == 1 &&
          row.q15_1_date !== "" &&
          row.q15_1_date !== "Invalid Date" &&
          DateInRange(row.q15_1_date, dayjs("01-01-1920"), dayjs()) &&
          !validateRadiotherapyDate(row.q15_1_date, row.earliestCohortIndexDate)
        ) {
          updatedRow.q15_1_date_Empty_Err = true;
          result = false;
        } else if (row.q15_1_date === "Invalid Date" && row.q15_1 === 1) {
          updatedRow.q15_1_DateInvalid = true;
          result = false;
        } else if (
          row.q15_1_date !== "Invalid Date" &&
          row.q15_1_date !== "" &&
          row.q15_1_date !== null &&
          row.q15_1 === 1 &&
          !DateInRange(row.q15_1_date, dayjs("01-01-1920"), dayjs())
        ) {
          updatedRow.q15_1_DateInvalid = true;
          result = false;
        }

        if (row.q15_2 == 1 && row.q15_2_date == "") {
          updatedRow.q15_2_date_Err = true;
          result = false;
        }

        if (
          row.q15_2 == 1 &&
          row.q15_2_date !== "" &&
          row.q15_2_date_Empty_Err
        ) {
          updatedRow.q15_2_date_Empty_Err = true;
          result = false;
        }

        if (row.q15_2 == null) {
          updatedRow.q15_2_hard_Err = true;
          result = false;
        } else {
          updatedRow.q15_2_hard_Err = false;
        }

        if (
          row.q15_2 == 1 &&
          row.q15_2_date !== "" &&
          row.q15_2_date !== "Invalid Date" &&
          DateInRange(row.q15_2_date, dayjs("01-01-1920"), dayjs()) &&
          !validateRadiotherapyDate(row.q15_2_date, row.earliestCohortIndexDate)
        ) {
          updatedRow.q15_2_date_Empty_Err = true;
          result = false;
        } else if (row.q15_2_date === "Invalid Date" && row.q15_2 === 1) {
          updatedRow.q15_2_DateInvalid = true;
          result = false;
        } else if (
          row.q15_2_date !== "Invalid Date" &&
          row.q15_2_date !== "" &&
          row.q15_2_date !== null &&
          row.q15_2 === 1 &&
          !DateInRange(row.q15_2_date, dayjs("01-01-1920"), dayjs())
        ) {
          updatedRow.q15_2_DateInvalid = true;
          result = false;
        }

        // Ensure Q15.1 ≤ Q15.2 (only when both dates are actually entered)
        if (
          row.q15_1_date &&
          row.q15_2_date &&
          row.q15_1_date !== "Invalid Date" &&
          row.q15_2_date !== "Invalid Date"
        ) {
          const q15_1_date = new Date(row.q15_1_date);
          const q15_2_date = new Date(row.q15_2_date);

          if (q15_1_date > q15_2_date) {
            //updatedRow.q15_1_date_Err = true;
            updatedRow.q15_2_date_Greater_Error = true;
            result = false;
          } else {
            // updatedRow.q15_1_date_Err = false;
            updatedRow.q15_2_date_Greater_Error = false;
          }
        }
      }

      // Q17.5 validation - ONLY validate if ndmm is FALSE
      if (!row.ndmm && isNewEcrfA) {
        updatedRow.q17_5_hard_Err = row.q17_5 === null;
        if (row.q17_5 === null) result = false;

        // Q17.6 VALIDATION - Only required if Q17.5 is "Present" (value 1)
        updatedRow.q17_6_hard_Err = row.q17_5 === 1 && row.q17_6 === null;
        if (updatedRow.q17_6_hard_Err) result = false;
      } else {
        updatedRow.q17_5_hard_Err = false;
        updatedRow.q17_6_hard_Err = false;
      }

      // Q17.1-Q17.4 validation - required once per qualifying LOT cohort (NDMM, or
      // bispecific/Tec/Tal/Elran/Linvo when Element C is enabled for the center)
      if (isDiseaseAssessmentResultsCohort(row, isNewEcrfC)) {
        updatedRow.q17_1_hard_Err = row.q17_1 === null;
        updatedRow.q17_2_hard_Err = row.q17_2 === null;
        updatedRow.q17_3_hard_Err = row.q17_3 === null;
        updatedRow.q17_4_hard_Err = row.q17_4 === null;
        if (
          updatedRow.q17_1_hard_Err ||
          updatedRow.q17_2_hard_Err ||
          updatedRow.q17_3_hard_Err ||
          updatedRow.q17_4_hard_Err
        ) {
          result = false;
        }
      } else {
        updatedRow.q17_1_hard_Err = false;
        updatedRow.q17_2_hard_Err = false;
        updatedRow.q17_3_hard_Err = false;
        updatedRow.q17_4_hard_Err = false;
      }

      return updatedRow;
    });
    setLotRows(updatedLotRows);
    return result;
  };

  const ValidateForm = () => {
    let result = true;
    // let datevalid = validateRadiotherapyDate(date, cohortIndexedDate);

    // QUESTION 11

    if (
      diseaseHist.q11_Percentage === null &&
      diseaseHist.q11_Percentage_txt == ""
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q11_hard_err: true,
      }));
      result = false;
    }

    if (
      diseaseHist.q11_Percentage == 1 &&
      (diseaseHist.q11_Percentage_txt !== "" ||
        diseaseHist.q11_Percentage_txt !== null)
    ) {
      const numValid = isValidNumber(diseaseHist.q11_Percentage_txt);
      setHardErrList((prev) => ({
        ...prev,
        q11_Percentage_Empty: !numValid,
      }));
      result = numValid ? true : false;
    }

    // QUESTION 12

    if (diseaseHist.q12_1 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_1_hard_err: true,
      }));
      result = false;
    }

    if (
      isNewEcrfA &&
      diseaseHist.q12_1 === 1 &&
      // diseaseHist.q11_Percentage === 1 &&
      // parseFloat(diseaseHist.q11_Percentage_txt) > 20 &&
      diseaseHist.q12_1_sub === null
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q12_1_sub_hard_err: true,
      }));
      result = false;
    }

    if (diseaseHist.q12_2 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_2_hard_err: true,
      }));
      result = false;
    }

    if (diseaseHist.q12_3 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_3_hard_err: true,
      }));
      result = false;
    }

    if (diseaseHist.q12_4 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_4_hard_err: true,
      }));
      result = false;
    }

    if (diseaseHist.q12_5 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_5_hard_err: true,
      }));
      result = false;
    }

    if (diseaseHist.q12_6 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_6_hard_err: true,
      }));
      result = false;
    }

    if (isNewEcrfA && diseaseHist.q12_7 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_7_hard_err: true,
      }));
      result = false;
    }

    if (isNewEcrfA && diseaseHist.q12_8 === null) {
      setHardErrList((prev) => ({
        ...prev,
        q12_8_hard_err: true,
      }));
      result = false;
    }

    if (
      isNewEcrfA &&
      diseaseHist.q12_8 === 1 &&
      diseaseHist.q12_8_sub === null
    ) {
      setHardErrList((prev) => ({
        ...prev,
        q12_8_sub_hard_err: true,
      }));
      result = false;
    }

    //Question 16
    if (shouldRenderDiv) {
      if (diseaseHist.q16_1 === null) {
        setHardErrList((prev) => ({
          ...prev,
          q16_1_hard_err: true,
        }));
        result = false;
      }

      if (diseaseHist.q16_2 === null) {
        setHardErrList((prev) => ({
          ...prev,
          q16_2_hard_err: true,
        }));
        result = false;
      }

      if (diseaseHist.q16_3 === null) {
        setHardErrList((prev) => ({
          ...prev,
          q16_3_hard_err: true,
        }));
        result = false;
      }

      if (diseaseHist.q16_4 === null) {
        setHardErrList((prev) => ({
          ...prev,
          q16_4_hard_err: true,
        }));
        result = false;
      }

      if (diseaseHist.q16_5 === null) {
        setHardErrList((prev) => ({
          ...prev,
          q16_5_hard_err: true,
        }));
        result = false;
      }

      if (diseaseHist.q16_6 === null) {
        setHardErrList((prev) => ({
          ...prev,
          q16_6_hard_err: true,
        }));
        result = false;
      }

      if (diseaseHist.q16_7 === null) {
        setHardErrList((prev) => ({
          ...prev,
          q16_7_hard_err: true,
        }));
        result = false;
      }
    }

    // Question 17.1-17.4 validation moved into the repeaterDiseaseHist map below -
    // it now runs once per qualifying cohort instead of a single shared instance.

    if (repeaterDiseaseHist && repeaterDiseaseHist.length > 0) {
      const updatedRepeaterDiseaseHist = repeaterDiseaseHist.map((row, idx) => {
        let updatedRow = { ...row };


        // Q17.1-Q17.6 validation now runs per LOT cohort in ValidateLotRows.

        return updatedRow;
      });
      setRepeaterDiseaseHist(updatedRepeaterDiseaseHist);
    }

    return result;
  };

  const formatDates = (dateString) => {
    if (isStringEmpty(dateString)) {
      return "";
    }
    // Create a Date object from the dateString
    let initialDate = new Date(dateString);

    // Subtract 183 days
    initialDate.setDate(initialDate.getDate() - 91);

    // Format the date as MMDDYYYY
    let formattedDate = `${(initialDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${initialDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${initialDate.getFullYear()}`;

    return formattedDate;
  };

  const formatDatesPlus30 = (dateString) => {
    if (isStringEmpty(dateString)) {
      return "";
    }
    const d = new Date(dateString);
    d.setDate(d.getDate() + 30);
    return `${(d.getMonth() + 1).toString().padStart(2, "0")}/${d
      .getDate()
      .toString()
      .padStart(2, "0")}/${d.getFullYear()}`;
  };

  const LoadData = async () => {
    try {
      if (pid > 0) {
        ToggleLoader(true);
        const response = await DiseaseHistoryService.LoadDiseaseHistory(pid);
        ToggleLoader(false);

        if (response?.status === HTTPResponse.OK) {
          const { data: rawData } = response;

          // Saved Disease History rows: one per drug / LOT. Everything except Q13-Q15.2 is
          // per drug, so the original load code below is fed only the drug's first-LOT row.
          const cohortModelList = rawData.cohortTreatmentModelList ?? [];
          const savedTreatmentList =
            rawData.diseaseHistory?.diseasehistorytreatmentList ?? [];
          const getCohortName = (item) =>
            (item.cohortTreatmentName === "DKRd (TE or TIE)"
              ? item.cohortTreatmentSCT === 1
                ? "DKRd (TE)"
                : item.cohortTreatmentSCT === 2
                  ? "DKRd (TIE)"
                  : item.cohortTreatmentName
              : item.cohortTreatmentName) || null;
          // Saved row for an exact LOT; rows saved before LOT was stored (no LOT) are
          // adopted by the cohort's first LOT.
          const findSavedRowForLot = (item, lineOfTherapy, isFirstLot) =>
            savedTreatmentList.find(
              (s) =>
                s.cohortTreatmentId === item.cohortTreatmentID &&
                (lineOfTherapy == null || s.lineOfTherapy === lineOfTherapy),
            ) ??
            (isFirstLot
              ? savedTreatmentList.find(
                  (s) =>
                    s.cohortTreatmentId === item.cohortTreatmentID &&
                    s.lineOfTherapy == null,
                )
              : undefined);
          const firstRowPerCohort = cohortModelList
            .map((item) => {
              const firstLot = !item.ndmm
                ? (item.receivedLinesOfTherapy ?? []).filter(
                    (lot) => lot.lineOfTherapy > 0,
                  )[0]?.lineOfTherapy
                : undefined;
              return findSavedRowForLot(item, firstLot ?? null, true);
            })
            .filter(Boolean);
          const data = rawData.diseaseHistory
            ? {
                ...rawData,
                diseaseHistory: {
                  ...rawData.diseaseHistory,
                  diseasehistorytreatmentList: firstRowPerCohort,
                },
              }
            : rawData;

          setIsNewEcrfA(data?.isNewEcrfA ?? false);
          setIsNewEcrfC(data?.isNewEcrfC ?? false);
          const elementCEnabled = data?.isNewEcrfC ?? false;

          const cohortTreatmentMap = new Map();
          if (data.cohortTreatmentModelList) {
            data.cohortTreatmentModelList.forEach((item) => {
              cohortTreatmentMap.set(item.cohortTreatmentID, {
                cohortTreatmentName:
                  item.cohortTreatmentName === "DKRd (TE or TIE)"
                    ? item.cohortTreatmentSCT === 1
                      ? "DKRd (TE)"
                      : item.cohortTreatmentSCT === 2
                        ? "DKRd (TIE)"
                        : item.cohortTreatmentName
                    : item.cohortTreatmentName,
                cohortIndexDate: item.cohortIndexDate,
                cohortTreatmentNameSuperscript:
                  item.cohortTreatmentNameSuperscript,
                earliestCohortIndexDate: item.earliestCohortIndexDate,
                cohortIndexDateMin91: item.cohortIndexDateMin91,
                cohortIndexDatePlus30: item.cohortIndexDatePlus30,
                ndmm: item.ndmm,
              });
            });

            const hasIfNdmm = data.cohortTreatmentModelList.some(
              (item) => item.ndmm,
            );
            setShouldRenderDiv(hasIfNdmm);
          }

          // Q17.1-Q17.4: NDMM cohorts load/save these on Diseasehistory (patient/round level).
          // Bispecific/Element C cohorts (Tec/Tal/Elran/Linvo) load/save the same 4 answers per
          // cohort from Diseasehistorytreatment instead - see isDiseaseAssessmentResultsCohort.
          const repeaterData = [];

          if (
            data.diseaseHistory != null &&
            data.diseaseHistory.diseasehistorytreatmentList != null
          ) {
            data.diseaseHistory.diseasehistorytreatmentList.forEach((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohortTreatmentId) || {};
              const isNdmmRow = cohortTreatment.ndmm || false;
              const isBispecificAssessmentRow =
                elementCEnabled &&
                isBispecificDiseaseAssessmentCohort(item.cohortTreatmentId);

              repeaterData.push({
                cohortTreatmentId: item.cohortTreatmentId,
                cohortTreatmentName:
                  cohortTreatment.cohortTreatmentName || null,
                cohortIndexDate: cohortTreatment.cohortIndexDate || null,
                earliestCohortIndexDate:
                  cohortTreatment.earliestCohortIndexDate || null,
                cohortIndexDateMin91:
                  cohortTreatment.cohortIndexDateMin91 || null,
                cohortIndexDatePlus30:
                  cohortTreatment.cohortIndexDatePlus30 || null,
                ndmm: cohortTreatment.ndmm || false,
                cohortTreatmentNameSuperscript:
                  cohortTreatment.cohortTreatmentNameSuperscript || null,
                diseasehistorytreatmentId: item.diseasehistorytreatmentid,
                diseaseHistoryId: data.diseaseHistory.diseasehistoryid,
                q13: item.rissSystem || null,
                q13_hard_Err: false,
                q14: item.mmType || null,
                q14_hard_Err: false,
                q15: item.radiotherapyTreatment || null,
                q15_1_date: item.radiotherapyDate,
                q15_1: item.radiotherapyDateUnk
                  ? 99
                  : !isStringEmpty(item.radiotherapyDate)
                    ? 1
                    : null,
                q15_2_date: item.radiotherapyLastdate,
                q15_2: item.radiotherapyLastdateUnk
                  ? 99
                  : !isStringEmpty(item.radiotherapyLastdate)
                    ? 1
                    : null,
                q17_5: item.resultExtramedullaryDisease || null,
                q17_5_hard_Err: false,
                q17_6: item.resultExtramedullaryDiseasePresent || null,
                q17_6_hard_Err: false,
                q17_1: isNdmmRow
                  ? (data.diseaseHistory.resultBonelesions ?? null)
                  : isBispecificAssessmentRow
                    ? (item.resultBonelesions ?? null)
                    : null,
                q17_1_hard_Err: false,
                q17_2: isNdmmRow
                  ? (data.diseaseHistory.resultExtramedullary ?? null)
                  : isBispecificAssessmentRow
                    ? (item.resultExtramedullary ?? null)
                    : null,
                q17_2_hard_Err: false,
                q17_3: isNdmmRow
                  ? (data.diseaseHistory.resultPlasmacytoma ?? null)
                  : isBispecificAssessmentRow
                    ? (item.resultPlasmacytoma ?? null)
                    : null,
                q17_3_hard_Err: false,
                q17_4: isNdmmRow
                  ? (data.diseaseHistory.resultParamedullary ?? null)
                  : isBispecificAssessmentRow
                    ? (item.resultParamedullary ?? null)
                    : null,
                q17_4_hard_Err: false,
                q12_9: item.beta2 || null,
                q12_9_hard_Err: false,
                q12_10: item.creatinine || null,
                q12_10_hard_Err: false,
                q15_hard_Err: false,
                q15_1_hard_Err: false,
                q15_2_hard_Err: false,
                q15_1_date_Err: false,
                q15_1_DateInvalid: false,
                q15_2_DateInvalid: false,
                q15_2_date_Err: false,
                q15_date_Err: false,
                q15_1_date_Empty_Err: false,
                q15_2_date_Empty_Err: false,
                q15_2_date_Greater_Error: false,
              });
            });
          }

          // Add new items from cohortTreatmentModelList that don't exist in diseasehistorytreatmentList
          data.cohortTreatmentModelList.forEach((item) => {
            const exists =
              data.diseaseHistory?.diseasehistorytreatmentList?.some(
                (treatment) =>
                  treatment.cohortTreatmentId === item.cohortTreatmentID,
              );
            if (!exists) {
              repeaterData.push({
                cohortTreatmentId: item.cohortTreatmentID,
                cohortTreatmentName:
                  (item.cohortTreatmentName === "DKRd (TE or TIE)"
                    ? item.cohortTreatmentSCT === 1
                      ? "DKRd (TE)"
                      : item.cohortTreatmentSCT === 2
                        ? "DKRd (TIE)"
                        : item.cohortTreatmentName
                    : item.cohortTreatmentName) || null,
                cohortIndexDate: item.cohortIndexDate || null,
                earliestCohortIndexDate: item.earliestCohortIndexDate || null,
                ndmm: item.ndmm || false,
                cohortIndexDateMin91: item.cohortIndexDateMin91 || null,
                cohortIndexDatePlus30: item.cohortIndexDatePlus30 || null,
                cohortTreatmentNameSuperscript:
                  item.cohortTreatmentNameSuperscript || null,
                diseasehistorytreatmentId: 0,
                diseaseHistoryId: data.diseaseHistory?.diseasehistoryid || 0,
                q13: null,
                q13_hard_Err: false,
                q14: null,
                q14_hard_Err: false,
                q15: null,
                q15_1: null,
                q15_2: null,
                q15_hard_Err: false,
                q15_1_date: "",
                q15_1_default_date: null,
                q15_2_date: null,
                q15_2_default_date: null,
                q15_date_Err: false,
                q15_1_hard_Err: false,
                q15_1_date_Err: false,
                q15_1_DateInvalid: false,
                q15_2_DateInvalid: false,
                q15_2_hard_Err: false,
                q15_2_date_Err: false,
                q15_2_date_Greater_Error: false,
                q17_5: null,
                q17_5_hard_Err: false,
                q17_6: null,
                q17_6_hard_Err: false,
                q17_1: item.ndmm
                  ? (data.diseaseHistory?.resultBonelesions ?? null)
                  : null,
                q17_1_hard_Err: false,
                q17_2: item.ndmm
                  ? (data.diseaseHistory?.resultExtramedullary ?? null)
                  : null,
                q17_2_hard_Err: false,
                q17_3: item.ndmm
                  ? (data.diseaseHistory?.resultPlasmacytoma ?? null)
                  : null,
                q17_3_hard_Err: false,
                q17_4: item.ndmm
                  ? (data.diseaseHistory?.resultParamedullary ?? null)
                  : null,
                q17_4_hard_Err: false,
                q12_9: null,
                q12_9_hard_Err: false,
                q12_10: null,
                q12_10_hard_Err: false,
              });
            }
          });

          // ---- Q13-Q15.2 only: one row per NDMM cohort / Bispecific-CAR-T LOT cohort ----
          const loopEntries = [];
          cohortModelList.forEach((item) => {
            const lots = !item.ndmm
              ? (item.receivedLinesOfTherapy ?? []).filter(
                  (lot) => lot.lineOfTherapy > 0,
                )
              : [];
            if (lots.length > 0) {
              lots.forEach((lot, lotIdx) =>
                loopEntries.push({
                  item,
                  lineOfTherapy: lot.lineOfTherapy,
                  indexDate: lot.indexDate || item.earliestCohortIndexDate,
                  isFirstLot: lotIdx === 0,
                }),
              );
            } else {
              loopEntries.push({
                item,
                lineOfTherapy: null,
                indexDate: item.earliestCohortIndexDate,
                isFirstLot: true,
              });
            }
          });

          const lotData = loopEntries.map(
            ({ item, lineOfTherapy, indexDate, isFirstLot }) => {
              const saved = findSavedRowForLot(item, lineOfTherapy, isFirstLot);
              return {
                cohortTreatmentId: item.cohortTreatmentID,
                lineOfTherapy: lineOfTherapy,
                isFirstLot: isFirstLot,
                cohortTreatmentName: getCohortName(item),
                cohortTreatmentNameSuperscript:
                  item.cohortTreatmentNameSuperscript || null,
                cohortIndexDate: item.cohortIndexDate || null,
                earliestCohortIndexDate: indexDate || null,
                cohortIndexDateMin91: lineOfTherapy
                  ? formatDates(indexDate) || item.cohortIndexDateMin91 || null
                  : item.cohortIndexDateMin91 || null,
                ndmm: item.ndmm || false,
                diseasehistorytreatmentId: saved?.diseasehistorytreatmentid ?? 0,
                cohortIndexDatePlus30: lineOfTherapy
                  ? formatDatesPlus30(indexDate) ||
                    item.cohortIndexDatePlus30 ||
                    null
                  : item.cohortIndexDatePlus30 || null,
                // Q12.9.A / Q12.10.A are per LOT
                q12_9: saved?.beta2 || null,
                q12_9_hard_Err: false,
                q12_10: saved?.creatinine || null,
                q12_10_hard_Err: false,
                // Q17.1-Q17.4: NDMM loads from Diseasehistory (no LOT); bispecific/Element C
                // cohorts load per LOT from Diseasehistorytreatment. Q17.5/17.6 always per LOT.
                q17_1: item.ndmm
                  ? (rawData.diseaseHistory?.resultBonelesions ?? null)
                  : isBispecificDiseaseAssessmentCohort(item.cohortTreatmentID)
                    ? (saved?.resultBonelesions ?? null)
                    : null,
                q17_1_hard_Err: false,
                q17_2: item.ndmm
                  ? (rawData.diseaseHistory?.resultExtramedullary ?? null)
                  : isBispecificDiseaseAssessmentCohort(item.cohortTreatmentID)
                    ? (saved?.resultExtramedullary ?? null)
                    : null,
                q17_2_hard_Err: false,
                q17_3: item.ndmm
                  ? (rawData.diseaseHistory?.resultPlasmacytoma ?? null)
                  : isBispecificDiseaseAssessmentCohort(item.cohortTreatmentID)
                    ? (saved?.resultPlasmacytoma ?? null)
                    : null,
                q17_3_hard_Err: false,
                q17_4: item.ndmm
                  ? (rawData.diseaseHistory?.resultParamedullary ?? null)
                  : isBispecificDiseaseAssessmentCohort(item.cohortTreatmentID)
                    ? (saved?.resultParamedullary ?? null)
                    : null,
                q17_4_hard_Err: false,
                q17_5: saved?.resultExtramedullaryDisease || null,
                q17_5_hard_Err: false,
                q17_6: saved?.resultExtramedullaryDiseasePresent || null,
                q17_6_hard_Err: false,
                q13: saved?.rissSystem || null,
                q13_hard_Err: false,
                q14: saved?.mmType || null,
                q14_hard_Err: false,
                q15: saved?.radiotherapyTreatment || null,
                q15_hard_Err: false,
                q15_1: saved?.radiotherapyDateUnk
                  ? 99
                  : !isStringEmpty(saved?.radiotherapyDate)
                    ? 1
                    : null,
                q15_1_date: saved?.radiotherapyDate ?? "",
                q15_1_hard_Err: false,
                q15_1_date_Err: false,
                q15_1_DateInvalid: false,
                q15_1_date_Empty_Err: false,
                q15_2: saved?.radiotherapyLastdateUnk
                  ? 99
                  : !isStringEmpty(saved?.radiotherapyLastdate)
                    ? 1
                    : null,
                q15_2_date: saved?.radiotherapyLastdate ?? "",
                q15_2_hard_Err: false,
                q15_2_date_Err: false,
                q15_2_DateInvalid: false,
                q15_2_date_Empty_Err: false,
                q15_2_date_Greater_Error: false,
              };
            },
          );

          setRepeaterDiseaseHist(repeaterData);
          setLotRows(lotData);

          if (data.diseaseHistory != null) {
            setDiseaseHist((prev) => ({
              ...prev,
              diseaseHistoryId: data.diseaseHistory.diseasehistoryid,
              q11_Percentage_txt: data.diseaseHistory.plasmaPercentage ?? "",
              q11_Percentage:
                !isStringEmptyDh(data.diseaseHistory.plasmaPercentage) ||
                data.diseaseHistory.plasmaPercentage === "0"
                  ? 1
                  : data.diseaseHistory.plasmaPercentageUnk
                    ? 99
                    : null,
              q12_1: data.diseaseHistory.mutationDel,
              q12_1_sub: data.diseaseHistory.mutationDelYes || null,
              q12_2: data.diseaseHistory.mutationT14,
              q12_3: data.diseaseHistory.mutationT16,
              q12_4: data.diseaseHistory.mutationT20,
              q12_5: data.diseaseHistory.mutation1q21Gain,
              q12_6: data.diseaseHistory.mutation1q21Amplification,
              q12_7: data.diseaseHistory.mutationTP53,
              q12_8: data.diseaseHistory.del1p32,
              q12_8_sub: data.diseaseHistory.del1p32Yes || null,
              q16_1: data.diseaseHistory.crabdiagnosisHypercalcemia,
              q16_2: data.diseaseHistory.crabdiagnosisRenal,
              q16_3: data.diseaseHistory.crabdiagnosisAnemia,
              q16_4: data.diseaseHistory.crabdiagnosisBonelesion,
              q16_5: data.diseaseHistory.crabdiagnosisBonemarrow,
              q16_6: data.diseaseHistory.crabdiagnosisSerumfree,
              q16_7: data.diseaseHistory.crabdiagnosisMri,
            }));
          }
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  };

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);
      setHardErrList(InitialHardErrList);
      let isValid = true;
      if (validate) {
        // run both so every error is shown
        const formValid = ValidateForm();
        const lotValid = ValidateLotRows();
        isValid = formValid && lotValid;
      }
      if (isValid) {
        setShowTopErrMsg(false);

        // Q17.1-Q17.4: bispecific/Element C cohorts (Tec/Tal/Elran/Linvo) save their answers
        // per cohort on Diseasehistorytreatment (below); NDMM saves on Diseasehistory instead
        // (further below, from whichever repeaterDiseaseHist row is the NDMM cohort).
        const repeaterData = repeaterDiseaseHist.map((test) => {
          const isBispecificAssessmentRow =
            isNewEcrfC &&
            isBispecificDiseaseAssessmentCohort(test.cohortTreatmentId);

          return {
            Diseasehistorytreatmentid: test.diseasehistorytreatmentId,
            CohortTreatmentId: test.cohortTreatmentId,
            RissSystem: test.q13,
            MmType: test.q14,
            RadiotherapyTreatment: test.q15,
            RadiotherapyDate:
              test.q15 == 1 && test.q15_1_date != "Invalid Date"
                ? test.q15_1_date
                : test.q15_1_date === "Invalid Date"
                  ? ""
                  : "",
            RadiotherapyDateUnk: test.q15_1 == 99,
            RadiotherapyLastdate:
              test.q15 == 1 && test.q15_2_date != "Invalid Date"
                ? test.q15_2_date
                : test.q15_2_date === "Invalid Date"
                  ? ""
                  : "",
            RadiotherapyLastdateUnk: test.q15_2 == 99,
            ResultExtramedullaryDisease: test.q17_5,
            ResultExtramedullaryDiseasePresent: test.q17_6,
            Beta2: test.q12_9,
            Creatinine: test.q12_10,
            ResultBonelesions: isBispecificAssessmentRow ? test.q17_1 : null,
            ResultExtramedullary: isBispecificAssessmentRow ? test.q17_2 : null,
            ResultPlasmacytoma: isBispecificAssessmentRow ? test.q17_3 : null,
            ResultParamedullary: isBispecificAssessmentRow ? test.q17_4 : null,
          };
        });

        // Q13-Q15.2 are per LOT: one payload row per LOT row. The per-drug answers above
        const payloadRows = lotRows.map((lotRow) => {
          const isBispecificLot =
            isNewEcrfC &&
            isBispecificDiseaseAssessmentCohort(lotRow.cohortTreatmentId);
          const perDrugRow = lotRow.isFirstLot
            ? repeaterData.find(
                (r) => r.CohortTreatmentId === lotRow.cohortTreatmentId,
              )
            : null;

          return {
            ...(perDrugRow ?? {}),
            Diseasehistorytreatmentid: lotRow.diseasehistorytreatmentId,
            CohortTreatmentId: lotRow.cohortTreatmentId,
            LineOfTherapy: lotRow.lineOfTherapy ?? null,
            Beta2: lotRow.q12_9,
            Creatinine: lotRow.q12_10,
            RissSystem: lotRow.q13,
            MmType: lotRow.q14,
            RadiotherapyTreatment: lotRow.q15,
            RadiotherapyDate:
              lotRow.q15 == 1 && lotRow.q15_1_date != "Invalid Date"
                ? lotRow.q15_1_date
                : "",
            RadiotherapyDateUnk: lotRow.q15_1 == 99,
            RadiotherapyLastdate:
              lotRow.q15 == 1 && lotRow.q15_2_date != "Invalid Date"
                ? lotRow.q15_2_date
                : "",
            RadiotherapyLastdateUnk: lotRow.q15_2 == 99,
            // Q17.1-Q17.6 are per LOT cohort. Q17.1-Q17.4 are only stored here for
            // bispecific/Element C cohorts; NDMM saves them on Diseasehistory below.
            ResultExtramedullaryDisease: lotRow.q17_5,
            ResultExtramedullaryDiseasePresent: lotRow.q17_6,
            ResultBonelesions: isBispecificLot ? lotRow.q17_1 : null,
            ResultExtramedullary: isBispecificLot ? lotRow.q17_2 : null,
            ResultPlasmacytoma: isBispecificLot ? lotRow.q17_3 : null,
            ResultParamedullary: isBispecificLot ? lotRow.q17_4 : null,
          };
        });

        const ndmmDiseaseAssessmentRow = lotRows.find((row) => row.ndmm);

        const diseaseHistModel = {
          patientId: pid,
          plasmaPercentage: diseaseHist.q11_Percentage_txt,
          plasmaPercentageUnk: diseaseHist.q11_Percentage == 99,
          mutationDel: diseaseHist.q12_1,
          mutationDelYes: diseaseHist.q12_1_sub,
          mutationT14: diseaseHist.q12_2,
          mutationT16: diseaseHist.q12_3,
          mutationT20: diseaseHist.q12_4,
          mutation1q21Gain: diseaseHist.q12_5,
          mutation1q21Amplification: diseaseHist.q12_6,
          mutationTP53: diseaseHist.q12_7,
          del1p32: diseaseHist.q12_8,
          del1p32Yes: diseaseHist.q12_8_sub,
          CrabdiagnosisHypercalcemia: shouldRenderDiv
            ? diseaseHist.q16_1
            : null,
          CrabdiagnosisRenal: shouldRenderDiv ? diseaseHist.q16_2 : null,
          CrabdiagnosisAnemia: shouldRenderDiv ? diseaseHist.q16_3 : null,
          CrabdiagnosisBonelesion: shouldRenderDiv ? diseaseHist.q16_4 : null,
          CrabdiagnosisBonemarrow: shouldRenderDiv ? diseaseHist.q16_5 : null,
          CrabdiagnosisSerumfree: shouldRenderDiv ? diseaseHist.q16_6 : null,
          CrabdiagnosisMri: shouldRenderDiv ? diseaseHist.q16_7 : null,
          ResultBonelesions: ndmmDiseaseAssessmentRow?.q17_1 ?? null,
          ResultExtramedullary: ndmmDiseaseAssessmentRow?.q17_2 ?? null,
          ResultPlasmacytoma: ndmmDiseaseAssessmentRow?.q17_3 ?? null,
          ResultParamedullary: ndmmDiseaseAssessmentRow?.q17_4 ?? null,
          DiseasehistorytreatmentList: payloadRows,
          UserId: GetLoggedInUserID(),
          isValidated: validate,
          IsAdmin: IsAdmin(),
        };

        if (pid > 0) {
          let response =
            await DiseaseHistoryService.SaveDiseaseHistory(diseaseHistModel);

          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
            await LoadData(pid);
          }

          ToggleLoader(false);
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  useEffect(() => {
    LoadData();
  }, [pid]);

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu activePageId={SideMenuItems.DiseaseHistory} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              // onclick="toggleNav()"
              onClick={() => toggleNav()}
            >
              <i
                id="arrowNavigation"
                class="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>DISEASE HISTORY</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section">
                <div className="survey-question-content">
                  <div className="question-answer">
                    {/* Question 11. */}
                    <div className="question-bot-sapce">
                      <div className="question question-weight">
                        <span>Q11.</span>
                        <span className="quest-text-pad">
                          Percentage of monoclonal plasma cells in bone marrow
                          reported at the initial MM diagnosis
                        </span>
                      </div>
                      <div className="double-dig-answer">
                        <label htmlFor="race_other">
                          <input
                            type="radio"
                            id="q11_Percentage"
                            name="q11_Percentage"
                            value={1}
                            checked={diseaseHist.q11_Percentage === 1}
                            onChange={HandleFieldChange}
                          />
                        </label>
                        <label htmlFor="race_other">
                          <span className="radio-text-padding">
                            <input
                              className="input-dash"
                              name="q11_Percentage_txt"
                              type="text"
                              value={diseaseHist.q11_Percentage_txt} //tk state
                              onKeyDown={(e) => {
                                // Allow backspace, arrow keys, and delete
                                if (
                                  [
                                    "Backspace",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Delete",
                                    "Tab",
                                  ].includes(e.key)
                                ) {
                                  return;
                                }

                                // Prevent non-numeric characters, except '.'
                                if (!/[0-9.]/.test(e.key)) {
                                  e.preventDefault();
                                  return;
                                }

                                const value = e.target.value;
                                const selectionStart = e.target.selectionStart;
                                const newValue =
                                  value.slice(0, selectionStart) +
                                  e.key +
                                  value.slice(e.target.selectionEnd);

                                // Prevent multiple '.'
                                if (e.key === "." && value.includes(".")) {
                                  e.preventDefault();
                                  return;
                                }

                                // Prevent '.' as the first character
                                if (e.key === "." && value === "") {
                                  e.preventDefault();
                                  return;
                                }

                                // Allow only one digit after decimal point
                                if (
                                  newValue.includes(".") &&
                                  newValue.split(".")[1].length > 1
                                ) {
                                  e.preventDefault();
                                  return;
                                }
                              }}
                              onChange={HandleFieldChange}
                            />{" "}
                            %
                          </span>
                        </label>
                      </div>

                      <ErrorField
                        show={hardErrList.q11_Percentage_Empty}
                        message={DiseaseHistErrorMsg.RangeErrMsg}
                      />
                      <div className="double-dig-answer">
                        <div className="option-without-input">
                          <label>
                            <input
                              type="radio"
                              id="q11_Percentage"
                              name="q11_Percentage"
                              value={99}
                              checked={diseaseHist.q11_Percentage === 99}
                              onChange={HandleFieldChange}
                            />

                            <span className="radio-text-padding">Unknown</span>
                          </label>
                        </div>
                      </div>
                      <ErrorField
                        show={hardErrList.q11_hard_err}
                        message={DiseaseHistErrorMsg.ProvideOptions}
                      />
                    </div>
                    {/* Question 12. */}
                    <div className="question-bot-sapce">
                      <div className="question question-weight">
                        <span>Q12.</span>
                        <span className="quest-text-pad">
                          Which of the following cytogenic mutations have been
                          recorded for the patient?
                        </span>
                      </div>
                    </div>
                    <div className="sub-question NdmmChar" style={{}}>
                      <table
                        style={{
                          border: "1px solid black",
                          borderCollapse: "collapse",
                          width: "100%",
                        }}
                      >
                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <span className="sub-question-quest">Q12.1.</span>
                            <span className="quest-text-pad">
                              Del(17p), identified since initial MM diagnosis
                            </span>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="disease_Hist_12_1"
                                    name="q12_1"
                                    value={1}
                                    checked={diseaseHist.q12_1 === 1}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Yes
                                  </span>
                                </label>
                              </div>
                            </div>
                            {diseaseHist.q12_1 === 1 &&
                              // diseaseHist.q11_Percentage === 1 &&
                              // parseFloat(diseaseHist.q11_Percentage_txt) > 20  &&
                              isNewEcrfA && (
                                <div
                                  style={{
                                    marginLeft: "30px",
                                    marginTop: "10px",
                                  }}
                                >
                                  <span>
                                    {">"}20% plasma cells with Del(17p)
                                  </span>
                                  <div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id="q12_1_sub_yes"
                                          name="q12_1_sub"
                                          value={1}
                                          checked={diseaseHist.q12_1_sub === 1}
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Yes
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id="q12_1_sub_no"
                                          name="q12_1_sub"
                                          value={2}
                                          checked={diseaseHist.q12_1_sub === 2}
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          No
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id="q12_1_sub_unknown"
                                          name="q12_1_sub"
                                          value={99}
                                          checked={diseaseHist.q12_1_sub === 99}
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.q12_1_sub_hard_err}
                                    message={DiseaseHistErrorMsg.ProvideOptions}
                                  />
                                </div>
                              )}
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="disease_Hist_12_1"
                                    name="q12_1"
                                    value={2}
                                    checked={diseaseHist.q12_1 === 2}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="disease_Hist_12_1"
                                    name="q12_1"
                                    value={99}
                                    checked={diseaseHist.q12_1 === 99}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Unknown/ Not tested
                                  </span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={hardErrList.q12_1_hard_err}
                              message={DiseaseHistErrorMsg.ProvideOptions}
                            />
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <span className="sub-question-quest">Q12.2.</span>
                            <span className="quest-text-pad">
                              t[4;14], identified since initial MM diagnosis
                            </span>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_2"
                                    name="q12_2"
                                    value={1}
                                    checked={diseaseHist.q12_2 === 1}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Yes
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_2"
                                    name="q12_2"
                                    value={2}
                                    checked={diseaseHist.q12_2 === 2}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_2"
                                    name="q12_2"
                                    value={99}
                                    checked={diseaseHist.q12_2 === 99}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Unknown/ Not tested
                                  </span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={hardErrList.q12_2_hard_err}
                              message={DiseaseHistErrorMsg.ProvideOptions}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <span className="sub-question-quest">Q12.3.</span>
                            <span className="quest-text-pad">
                              t[14;16], identified since initial MM diagnosis
                            </span>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_3"
                                    name="q12_3"
                                    value={1}
                                    checked={diseaseHist.q12_3 === 1}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Yes
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_3"
                                    name="q12_3"
                                    value={2}
                                    checked={diseaseHist.q12_3 === 2}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_3"
                                    name="q12_3"
                                    value={99}
                                    checked={diseaseHist.q12_3 === 99}
                                    onChange={HandleFieldChange}
                                  />
                                  <span className="radio-text-padding">
                                    Unknown/ Not tested
                                  </span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={hardErrList.q12_3_hard_err}
                              message={DiseaseHistErrorMsg.ProvideOptions}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <span className="sub-question-quest">Q12.4.</span>
                            <span className="quest-text-pad">
                              t[14;20], identified since initial MM diagnosis
                            </span>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_4"
                                    name="q12_4"
                                    value={1}
                                    checked={diseaseHist.q12_4 === 1}
                                    onChange={HandleFieldChange}
                                  />
                                  <span className="radio-text-padding">
                                    Yes
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_4"
                                    name="q12_4"
                                    value={2}
                                    checked={diseaseHist.q12_4 === 2}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_4"
                                    name="q12_4"
                                    value={99}
                                    checked={diseaseHist.q12_4 === 99}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Unknown/ Not tested
                                  </span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={hardErrList.q12_4_hard_err}
                              message={DiseaseHistErrorMsg.ProvideOptions}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <span className="sub-question-quest">Q12.5.</span>
                            <span className="quest-text-pad">
                              1q21 gain (3 copies), identified since initial MM
                              diagnosis
                            </span>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_5_yes"
                                    name="q12_5"
                                    value={1}
                                    checked={diseaseHist.q12_5 === 1}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Yes
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_5_no"
                                    name="q12_5"
                                    value={2}
                                    checked={diseaseHist.q12_5 === 2}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_5_unknown"
                                    name="q12_5"
                                    value={99}
                                    checked={diseaseHist.q12_5 === 99}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Unknown/ Not tested
                                  </span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={hardErrList.q12_5_hard_err}
                              message={DiseaseHistErrorMsg.ProvideOptions}
                            />
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <span className="sub-question-quest">Q12.6.</span>
                            <span className="quest-text-pad">
                              1q21 amplification (≥ 4 copies), identified since
                              initial MM diagnosis
                            </span>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                            }}
                          >
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_6"
                                    name="q12_6"
                                    value={1}
                                    checked={diseaseHist.q12_6 === 1}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Yes
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_6"
                                    name="q12_6"
                                    value={2}
                                    checked={diseaseHist.q12_6 === 2}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id="q12_6"
                                    name="q12_6"
                                    value={99}
                                    checked={diseaseHist.q12_6 === 99}
                                    onChange={HandleFieldChange}
                                  />

                                  <span className="radio-text-padding">
                                    Unknown/ Not tested
                                  </span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={hardErrList.q12_6_hard_err}
                              message={DiseaseHistErrorMsg.ProvideOptions}
                            />
                          </td>
                        </tr>
                        {isNewEcrfA && (
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <span className="sub-question-quest">
                                Q12.7.A.
                              </span>
                              <span className="quest-text-pad">
                                TP53, identified since initial MM diagnosis
                              </span>
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <div>
                                <div className="option-without-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id="q12_7"
                                      name="q12_7"
                                      value={1}
                                      checked={diseaseHist.q12_7 === 1}
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      Yes
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div>
                                <div className="option-without-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id="q12_7"
                                      name="q12_7"
                                      value={2}
                                      checked={diseaseHist.q12_7 === 2}
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      No
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div>
                                <div className="option-without-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id="q12_7"
                                      name="q12_7"
                                      value={99}
                                      checked={diseaseHist.q12_7 === 99}
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      Unknown/ Not tested
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <ErrorField
                                show={hardErrList.q12_7_hard_err}
                                message={DiseaseHistErrorMsg.ProvideOptions}
                              />
                            </td>
                          </tr>
                        )}
                        {isNewEcrfA && (
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <span className="sub-question-quest">
                                Q12.8.A.
                              </span>
                              <span className="quest-text-pad">
                                del(1p32), identified since initial MM diagnosis
                              </span>
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <div>
                                <div className="option-without-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id="disease_Hist_12_8"
                                      name="q12_8"
                                      value={1}
                                      checked={diseaseHist.q12_8 === 1}
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      Yes
                                    </span>
                                  </label>
                                </div>
                              </div>
                              {diseaseHist.q12_8 === 1 && (
                                <div
                                  style={{
                                    marginLeft: "30px",
                                    marginTop: "10px",
                                  }}
                                >
                                  <div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id="q12_8_sub_yes"
                                          name="q12_8_sub"
                                          value={1}
                                          checked={diseaseHist.q12_8_sub === 1}
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Monoallelic
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id="q12_8_sub_no"
                                          name="q12_8_sub"
                                          value={2}
                                          checked={diseaseHist.q12_8_sub === 2}
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Biallelic
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id="q12_8_sub_unknown"
                                          name="q12_8_sub"
                                          value={99}
                                          checked={diseaseHist.q12_8_sub === 99}
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.q12_8_sub_hard_err}
                                    message={DiseaseHistErrorMsg.ProvideOptions}
                                  />
                                </div>
                              )}
                              <div>
                                <div className="option-without-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id="disease_Hist_12_8"
                                      name="q12_8"
                                      value={2}
                                      checked={diseaseHist.q12_8 === 2}
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      No
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div>
                                <div className="option-without-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id="disease_Hist_12_8"
                                      name="q12_8"
                                      value={99}
                                      checked={diseaseHist.q12_8 === 99}
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      Unknown/ Not tested
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <ErrorField
                                show={hardErrList.q12_8_hard_err}
                                message={DiseaseHistErrorMsg.ProvideOptions}
                              />
                            </td>
                          </tr>
                        )}
                      </table>
                    </div>

                    {lotRows.map((data, index) => {
                      const matchedLot = data;
                      return (
                      <div key={index}>
                        {isNewEcrfA && (
                          <>
                            <div className="dependent-section">
                              <CollapsibleSectionHeader
                                title={
                                  <>
                                    {matchedLot?.lineOfTherapy
                                      ? `${matchedLot.lineOfTherapy}L – `
                                      : ""}
                                    {data.cohortTreatmentName}
                                    {data.cohortTreatmentNameSuperscript ==
                                    null ? (
                                      ""
                                    ) : (
                                      <>
                                        <sup className="supscript">
                                          {data.cohortTreatmentNameSuperscript.slice(
                                            0,
                                            2,
                                          )}
                                        </sup>
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          2,
                                        )}
                                      </>
                                    )}
                                  </>
                                }
                                isExpanded={!isDhABlockCollapsed(index)}
                                onToggle={() => toggleDhABlock(index)}
                                hasError={
                                  !!(data.q12_9_hard_Err || data.q12_10_hard_Err)
                                }
                              />
                              <Collapse in={!isDhABlockCollapsed(index)}>
                              <div>
                              <div className="question-bot-space">
                                <div className="sub-question">
                                  <table
                                    style={{
                                      border: "1px solid black",
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <tbody>
                                      {/* Q12.9.A */}
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span className="sub-question-quest">
                                            Q12.9.A.
                                          </span>
                                          <span className="quest-text-pad">
                                            Beta-2 microglobulin result closest
                                            to index, identified{" "}
                                            <u>
                                              within 3 months before and 1 month
                                              after
                                            </u>{" "}
                                            the index date (
                                            <span
                                              style={{
                                                color:
                                                  PageDesignConstants.fontColor,
                                              }}
                                            >
                                              {data.cohortIndexDateMin91 ||
                                                "[index date – 91 days]"}
                                            </span>{" "}
                                            to{" "}
                                            <span
                                              style={{
                                                color:
                                                  PageDesignConstants.fontColor,
                                              }}
                                            >
                                              {data.cohortIndexDatePlus30 ||
                                                "[index date + 30 days]"}
                                            </span>
                                            )
                                          </span>
                                          <div style={{ marginTop: "8px" }}>
                                            <span>
                                              <b>Note:</b> if multiple records
                                              are available within the record
                                              selection window, please use the
                                              record closest to the index date.
                                            </span>
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={index}
                                                  name={`q12_9_${index}`}
                                                  value={1}
                                                  checked={data.q12_9 === 1}
                                                  onChange={
                                                    HandleLotFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  &lt;5.5 mg/L
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={index}
                                                  name={`q12_9_${index}`}
                                                  value={2}
                                                  checked={data.q12_9 === 2}
                                                  onChange={
                                                    HandleLotFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  &ge; 5.5 mg/L
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={index}
                                                  name={`q12_9_${index}`}
                                                  value={99}
                                                  checked={data.q12_9 === 99}
                                                  onChange={
                                                    HandleLotFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Unknown/ Not tested
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={data.q12_9_hard_Err}
                                            message={
                                              DiseaseHistErrorMsg.ProvideOptions
                                            }
                                          />
                                        </td>
                                      </tr>

                                      {/* Q12.10.A */}
                                      <tr>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span className="sub-question-quest">
                                            Q12.10.A.
                                          </span>
                                          <span className="quest-text-pad">
                                            Creatinine result closest to index,
                                            identified{" "}
                                            <u>
                                              within 3 months before and 1 month
                                              after
                                            </u>{" "}
                                            the index date (
                                            <span
                                              style={{
                                                color:
                                                  PageDesignConstants.fontColor,
                                              }}
                                            >
                                              {data.cohortIndexDateMin91 ||
                                                "[index date – 91 days]"}
                                            </span>{" "}
                                            to{" "}
                                            <span
                                              style={{
                                                color:
                                                  PageDesignConstants.fontColor,
                                              }}
                                            >
                                              {data.cohortIndexDatePlus30 ||
                                                "[index date + 30 days]"}
                                            </span>
                                            )
                                          </span>
                                          <div style={{ marginTop: "8px" }}>
                                            <span>
                                              <b>Note:</b> if multiple records
                                              are available within the record
                                              selection window, please use the
                                              record closest to the index date.
                                            </span>
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={index}
                                                  name={`q12_10_${index}`}
                                                  value={1}
                                                  checked={data.q12_10 === 1}
                                                  onChange={
                                                    HandleLotFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  &lt;1.2 mg/dL
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={index}
                                                  name={`q12_10_${index}`}
                                                  value={2}
                                                  checked={data.q12_10 === 2}
                                                  onChange={
                                                    HandleLotFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  &ge; 1.2 mg/dL
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="option-without-input">
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={index}
                                                  name={`q12_10_${index}`}
                                                  value={99}
                                                  checked={data.q12_10 === 99}
                                                  onChange={
                                                    HandleLotFieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Unknown/ Not tested
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={data.q12_10_hard_Err}
                                            message={
                                              DiseaseHistErrorMsg.ProvideOptions
                                            }
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              </div>
                              </Collapse>
                            </div>
                          </>
                        )}
                      </div>
                      );
                    })}

                    {/* Question 13 */}

                    {lotRows.map((data, index) => (
                      <div className="dependent-section">
                        <CollapsibleSectionHeader
                          title={
                            <>
                              {data.lineOfTherapy
                                ? `${data.lineOfTherapy}L – `
                                : ""}
                              {data.cohortTreatmentName}
                              {data.cohortTreatmentNameSuperscript == null ? (
                                ""
                              ) : (
                                <>
                                  <sup className="supscript">
                                    {data.cohortTreatmentNameSuperscript.slice(
                                      0,
                                      2,
                                    )}
                                  </sup>
                                  {data.cohortTreatmentNameSuperscript.slice(2)}
                                </>
                              )}
                            </>
                          }
                          isExpanded={!isDhBlockCollapsed(index)}
                          onToggle={() => toggleDhBlock(index)}
                          hasError={
                            !!(
                              data.q13_hard_Err ||
                              data.q14_hard_Err ||
                              data.q15_hard_Err ||
                              data.q15_1_hard_Err ||
                              data.q15_2_hard_Err ||
                              data.q15_1_date_Err ||
                              data.q15_2_date_Err ||
                              data.q15_1_DateInvalid ||
                              data.q15_2_DateInvalid ||
                              data.q15_1_date_Empty_Err ||
                              data.q15_2_date_Empty_Err ||
                              data.q15_2_date_Greater_Error
                            )
                          }
                        />
                        <Collapse in={!isDhBlockCollapsed(index)}>
                          <div>
                            {/* QUESTION 13 */}
                            <div className="question-bot-space">
                              <div className="question question-weight">
                                <span>Q13.</span>
                                <span className="quest-text-pad">
                                  Revised - International Staging System [R-ISS]
                                  on or closest to the initiation of{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {data.cohortTreatmentName}
                                    {data.cohortTreatmentNameSuperscript ==
                                    null ? (
                                      ""
                                    ) : (
                                      <>
                                        <sup className="supscript">
                                          {data.cohortTreatmentNameSuperscript.slice(
                                            0,
                                            2,
                                          )}
                                        </sup>
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          2,
                                        )}
                                      </>
                                    )}
                                  </span>{" "}
                                  on{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {data.earliestCohortIndexDate}
                                  </span>
                                  ? If R-ISS has been noted in the chart, chart
                                  abstractor can use it as stated and does not
                                  need to derive based on the criteria.
                                  Otherwise, please consider deriving based on
                                  the data available in the chart.
                                </span>
                              </div>
                              <div className="double-dig-answer">
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    // htmlFor={`q13_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q13_${index}`}
                                      value={1}
                                      checked={data.q13 === 1}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      I - Serum β2-microglobulin &lt; 3.5 mg/L,
                                      serum albumin ≥ 3.5 g/dL, standard-risk
                                      chromosomal abnormalities detected by
                                      iFISH, and normal serum lactase
                                      dehydrogenase (LDH)
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    //htmlFor={`q13_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q13_${index}`}
                                      value={2}
                                      checked={data.q13 === 2}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      II – Neither Stage I nor Stage III
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    // htmlFor={`q13_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q13_${index}`}
                                      value={3}
                                      checked={data.q13 === 3}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      III - Serum β2-microglobulin &gt; 5.5 mg/L
                                      and either high-risk chromosomal
                                      abnormalities detected by iFISH or high
                                      serum LDH
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    //htmlFor={`q13_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q13_${index}`}
                                      value={99}
                                      checked={data.q13 === 99}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      Unknown
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <ErrorField
                                show={data.q13_hard_Err}
                                message={DiseaseHistErrorMsg.ProvideOptions}
                              />
                            </div>

                            {/* QUESTION 14 */}
                            <div className="question-bot-space">
                              <div className="question question-weight">
                                <span>Q14.</span>
                                <span className="quest-text-pad">
                                  Type of measurable MM disease the patient has
                                  been diagnosed with on or closest to the
                                  initiation of{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {data.cohortTreatmentName}
                                    {data.cohortTreatmentNameSuperscript ==
                                    null ? (
                                      ""
                                    ) : (
                                      <>
                                        <sup className="supscript">
                                          {data.cohortTreatmentNameSuperscript.slice(
                                            0,
                                            2,
                                          )}
                                        </sup>
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          2,
                                        )}
                                      </>
                                    )}
                                  </span>{" "}
                                  on{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {data.earliestCohortIndexDate}
                                  </span>
                                  ?
                                </span>
                              </div>
                              <div className="double-dig-answer">
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    //htmlFor={`q14_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q14_${index}`}
                                      value={1}
                                      checked={data.q14 === 1}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      Serum measurable (e.g., IgG, IgA, etc.)
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    //htmlFor={`q14_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q14_${index}`}
                                      value={2}
                                      checked={data.q14 === 2}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      Urine measurable only
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    //htmlFor={`q14_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q14_${index}`}
                                      value={3}
                                      checked={data.q14 === 3}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      Serum free light chains only
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    //htmlFor={`q14_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q14_${index}`}
                                      value={4}
                                      checked={data.q14 === 4}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      No measurable disease – plasma cell only
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    //htmlFor={`q14_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q14_${index}`}
                                      value={99}
                                      checked={data.q14 === 99}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      Unknown
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <ErrorField
                                show={data.q14_hard_Err}
                                message={DiseaseHistErrorMsg.ProvideOptions}
                              />
                            </div>

                            {/* QUESTION 15 */}
                            <div className="question-bot-space">
                              <div className="question question-weight">
                                <span>Q15.</span>
                                <span className="quest-text-pad">
                                  Did the patient ever receive radiotherapy
                                  treatment on or <u>within 3 months prior</u>{" "}
                                  to initiating{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {data.cohortTreatmentName}
                                    {data.cohortTreatmentNameSuperscript ==
                                    null ? (
                                      ""
                                    ) : (
                                      <>
                                        <sup className="supscript">
                                          {data.cohortTreatmentNameSuperscript.slice(
                                            0,
                                            2,
                                          )}
                                        </sup>
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          2,
                                        )}
                                      </>
                                    )}
                                  </span>{" "}
                                  (i.e., from{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {formatDates(
                                      data.earliestCohortIndexDate,
                                    )}{" "}
                                  </span>{" "}
                                  to{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {data.earliestCohortIndexDate}
                                  </span>
                                  )?
                                </span>
                              </div>
                              <div className="double-dig-answer">
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    // htmlFor={`q15_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q15_${index}`}
                                      value={1}
                                      checked={data.q15 === 1}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      Yes
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    // htmlFor={`q15_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q15_${index}`}
                                      value={2}
                                      checked={data.q15 === 2}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      No
                                    </span>
                                  </label>
                                </div>
                                <div className="option-without-input">
                                  <label
                                    className="long-text-option"
                                    // htmlFor={`q15_${index}`}
                                  >
                                    <input
                                      type="radio"
                                      id={index}
                                      name={`q15_${index}`}
                                      value={99}
                                      checked={data.q15 === 99}
                                      onChange={HandleLotFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      Unknown
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <ErrorField
                                show={data.q15_hard_Err}
                                message={DiseaseHistErrorMsg.ProvideOptions}
                              />
                            </div>
                            {data.q15 == 1 && (
                              <div className="question-bot-space">
                                <div className="sub-question">
                                  <span className="sub-question-quest">
                                    Q15.1.
                                  </span>
                                  <span className="quest-text-pad">
                                    Date of first radiotherapy on or{" "}
                                    <u>within 3 months prior</u> to initiating{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "647",
                                      }}
                                    >
                                      {data.cohortTreatmentName}
                                    </span>
                                  </span>
                                  <div className="double-dig-answer">
                                    <div className="option-without-input">
                                      <input
                                        type="radio"
                                        id={index}
                                        name={`q15_1_${index}`}
                                        value={1}
                                        checked={data.q15_1 === 1}
                                        onChange={HandleLotFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        {/* <DateControl
                                      ctrlId={`q15_1_date-${index}`}
                                      HandleDateChange={
                                        HandleLotDateChange
                                      }
                                      //defDate={data.q15_1_default_date}
                                      date={data.q15_1_date}
                                    /> */}

                                        <DatePickerComponent
                                          ctrlId={`q15_1_date-${index}`}
                                          // selectedDate={selectedDate}
                                          // onDateChange={(newDate) => setSelectedDate(newDate)}
                                          HandleDateChange={HandleLotDateChange}
                                          //optionId={1}
                                          minDate={dayjs("01-01-1920")}
                                          maxDate={dayjs()}
                                          locale="en" // for dd/mm/yyyy use "en-gb"
                                          date={data.q15_1_date}
                                        />
                                      </span>
                                    </div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id={index}
                                          name={`q15_1_${index}`}
                                          value={99}
                                          checked={data.q15_1 === 99}
                                          onChange={HandleLotFieldChange}
                                        />

                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={data.q15_1_hard_Err}
                                    message={DiseaseHistErrorMsg.ProvideOptions}
                                  />

                                  <ErrorField
                                    show={data.q15_1_date_Err}
                                    message={
                                      DiseaseHistErrorMsg.DateFirstErrMsg
                                    }
                                  />

                                  <ErrorField
                                    show={data.q15_1_DateInvalid}
                                    message={CommonError_Msgs.InvalidDate}
                                  />
                                  <ErrorField
                                    show={data.q15_1_date_Empty_Err}
                                    message={DiseaseHistErrorMsg.DateFirstValidMsg.replace(
                                      "[Cohort]",
                                      `${data.lineOfTherapy ? `${data.lineOfTherapy}L – ` : ""}${data.cohortTreatmentName}`,
                                    ).replace(
                                      "[IndexDate]",
                                      data.earliestCohortIndexDate ?? "",
                                    )}
                                  />
                                </div>
                                <div className="sub-question">
                                  <span className="sub-question-quest">
                                    Q15.2.
                                  </span>
                                  <span className="quest-text-pad">
                                    Date of last radiotherapy on or{" "}
                                    <u>within 3 months prior</u> to initiating{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "647",
                                      }}
                                    >
                                      {data.cohortTreatmentName}
                                    </span>
                                  </span>
                                  <div className="double-dig-answer">
                                    <div className="option-without-input">
                                      <input
                                        type="radio"
                                        id={index}
                                        name={`q15_2_${index}`}
                                        value={1}
                                        checked={data.q15_2 === 1}
                                        onChange={HandleLotFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        {/* <DateControl
                                      ctrlId={`q15_2_date-${index}`}
                                      HandleDateChange={
                                        HandleLotDateChange
                                      }
                                      //defDate={data.q15_2_default_date}
                                      date={data.q15_2_date}
                                    /> */}
                                        <DatePickerComponent
                                          ctrlId={`q15_2_date-${index}`}
                                          // selectedDate={selectedDate}
                                          // onDateChange={(newDate) => setSelectedDate(newDate)}
                                          HandleDateChange={HandleLotDateChange}
                                          //optionId={1}
                                          minDate={dayjs("01-01-1920")}
                                          maxDate={dayjs()}
                                          locale="en" // for dd/mm/yyyy use "en-gb"
                                          date={data.q15_2_date}
                                        />
                                      </span>
                                    </div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id={index}
                                          name={`q15_2_${index}`}
                                          value={99}
                                          checked={data.q15_2 === 99}
                                          onChange={HandleLotFieldChange}
                                        />

                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={data.q15_2_hard_Err}
                                    message={DiseaseHistErrorMsg.ProvideOptions}
                                  />

                                  <ErrorField
                                    show={data.q15_2_DateInvalid}
                                    message={CommonError_Msgs.InvalidDate}
                                  />

                                  <ErrorField
                                    show={data.q15_2_date_Err}
                                    message={DiseaseHistErrorMsg.DateLastErrMsg}
                                  />

                                  <ErrorField
                                    show={data.q15_2_date_Greater_Error}
                                    message={
                                      "Date of first radiotherapy should be less than or equal to Date of last radiotherapy"
                                    }
                                  />

                                  <ErrorField
                                    show={data.q15_2_date_Empty_Err}
                                    message={DiseaseHistErrorMsg.DateLastValidMsg.replace(
                                      "[Cohort]",
                                      `${data.lineOfTherapy ? `${data.lineOfTherapy}L – ` : ""}${data.cohortTreatmentName}`,
                                    ).replace(
                                      "[IndexDate]",
                                      data.earliestCohortIndexDate ?? "",
                                    )}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </Collapse>
                      </div>
                    ))}
                    <div></div>
                    {/* Question 16 */}
                    {shouldRenderDiv && (
                      <div>
                        <div className="question-bot-sapce">
                          <div className="question question-weight">
                            <span>Q16.</span>
                            <span className="quest-text-pad">
                              Please provide any SLiM-CRAB diagnostic criteria
                              recorded in the patient’s chart at initial MM
                              diagnosis.
                            </span>
                          </div>
                        </div>
                        <div className="sub-question">
                          <table
                            style={{
                              border: "1px solid black",
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <div>
                              <b> Evidence of end organ damage</b>{" "}
                            </div>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <span className="sub-question-quest">
                                  Q16.1.
                                </span>
                                <span className="quest-text-pad">
                                  {
                                    "Hypercalcemia  (defined as serum calcium >0.25 mmol/L [>1 mg/dL] higher than the upper limit of normal or >2.75 mmol/L [>11 mg/dL]) "
                                  }
                                </span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_1"
                                        name="q16_1"
                                        value={1}
                                        checked={diseaseHist.q16_1 === 1}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_1"
                                        name="q16_1"
                                        value={2}
                                        checked={diseaseHist.q16_1 === 2}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_1"
                                        name="q16_1"
                                        value={99}
                                        checked={diseaseHist.q16_1 === 99}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Unknown/ Not tested
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.q16_1_hard_err}
                                  message={DiseaseHistErrorMsg.ProvideOptions}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <span className="sub-question-quest">
                                  Q16.2.
                                </span>
                                <span className="quest-text-pad">
                                  {
                                    "Renal insufficiency (defined as creatinine clearance <40 mL/min measured or estimated by validated equations, or serum creatinine >177 μmol/L [>2 mg/dL])"
                                  }
                                </span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_2"
                                        name="q16_2"
                                        value={1}
                                        checked={diseaseHist.q16_2 === 1}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_2"
                                        name="q16_2"
                                        value={2}
                                        checked={diseaseHist.q16_2 === 2}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_2"
                                        name="q16_2"
                                        value={99}
                                        checked={diseaseHist.q16_2 === 99}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Unknown/ Not tested
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.q16_2_hard_err}
                                  message={DiseaseHistErrorMsg.ProvideOptions}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <span className="sub-question-quest">
                                  Q16.3.
                                </span>
                                <span className="quest-text-pad">
                                  {
                                    "Anemia  (defined as hemoglobin value of >20 g/L below the lower limit of normal, or a hemoglobin value <100 g/L) "
                                  }
                                </span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_3"
                                        name="q16_3"
                                        value={1}
                                        checked={diseaseHist.q16_3 === 1}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_3"
                                        name="q16_3"
                                        value={2}
                                        checked={diseaseHist.q16_3 === 2}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_3"
                                        name="q16_3"
                                        value={99}
                                        checked={diseaseHist.q16_3 === 99}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Unknown/ Not tested
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.q16_3_hard_err}
                                  message={DiseaseHistErrorMsg.ProvideOptions}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <span className="sub-question-quest">
                                  Q16.4.
                                </span>
                                <span className="quest-text-pad">
                                  {
                                    "Lytic bone lesions  (i.e., one or more osteolytic lesions on skeletal radiography, computed tomography (CT), or Positron Emission Tomography [PET]-CT) "
                                  }
                                </span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_4"
                                        name="q16_4"
                                        value={1}
                                        checked={diseaseHist.q16_4 === 1}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_4"
                                        name="q16_4"
                                        value={2}
                                        checked={diseaseHist.q16_4 === 2}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_4"
                                        name="q16_4"
                                        value={99}
                                        checked={diseaseHist.q16_4 === 99}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Unknown/ Not tested
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.q16_4_hard_err}
                                  message={DiseaseHistErrorMsg.ProvideOptions}
                                />
                              </td>
                            </tr>
                            <div>
                              <b> Biomarkers of malignancy</b>{" "}
                            </div>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <span className="sub-question-quest">
                                  Q16.5.
                                </span>
                                <span className="quest-text-pad">
                                  {
                                    "Clonal bone marrow plasma cell percentage ≥ 60% "
                                  }
                                </span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_5"
                                        name="q16_5"
                                        value={1}
                                        checked={diseaseHist.q16_5 === 1}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_5"
                                        name="q16_5"
                                        value={2}
                                        checked={diseaseHist.q16_5 === 2}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_5"
                                        name="q16_5"
                                        value={99}
                                        checked={diseaseHist.q16_5 === 99}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Unknown/ Not tested
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.q16_5_hard_err}
                                  message={DiseaseHistErrorMsg.ProvideOptions}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <span className="sub-question-quest">
                                  Q 16.6.
                                </span>
                                <span className="quest-text-pad">
                                  {
                                    "Involved:uninvolved serum free light chain ratio ≥100 "
                                  }
                                </span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_6"
                                        name="q16_6"
                                        value={1}
                                        checked={diseaseHist.q16_6 === 1}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_6"
                                        name="q16_6"
                                        value={2}
                                        checked={diseaseHist.q16_6 === 2}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_6"
                                        name="q16_6"
                                        value={99}
                                        checked={diseaseHist.q16_6 === 99}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Unknown/ Not tested
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.q16_6_hard_err}
                                  message={DiseaseHistErrorMsg.ProvideOptions}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <span className="sub-question-quest">
                                  Q 16.7.
                                </span>
                                <span className="quest-text-pad">
                                  {
                                    "More than 1 focal lesion on magnetic resonance imaging (MRI) studies  "
                                  }
                                </span>
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_7"
                                        name="q16_7"
                                        value={1}
                                        checked={diseaseHist.q16_7 === 1}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_7"
                                        name="q16_7"
                                        value={2}
                                        checked={diseaseHist.q16_7 === 2}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <div className="double-dig-answer">
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="q16_7"
                                        name="q16_7"
                                        value={99}
                                        checked={diseaseHist.q16_7 === 99}
                                        onChange={HandleFieldChange}
                                      />

                                      <span className="radio-text-padding">
                                        Unknown/ Not tested
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.q16_7_hard_err}
                                  message={DiseaseHistErrorMsg.ProvideOptions}
                                />
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    )}
                    {/* Question 17.1-17.6 - repeated once per LOT cohort (Line_CohortID, e.g.
                        "2L Tec"), all in one table: Q17.1-17.4 for NDMM cohorts and (when
                        Element C is enabled) bispecific cohorts (Tec/Tal/Elran/Linvo);
                        Q17.5/17.6 for non-NDMM cohorts when Element A is enabled. A cohort
                        can qualify for both. */}
                    {lotRows
                      .map((data, originalIndex) => ({ data, originalIndex }))
                      .filter(
                        ({ data }) =>
                          isDiseaseAssessmentResultsCohort(data, isNewEcrfC) ||
                          (!data.ndmm && isNewEcrfA),
                      )
                      .map(({ data, originalIndex }) => {
                        const showQ17_1to4 = isDiseaseAssessmentResultsCohort(
                          data,
                          isNewEcrfC,
                        );
                        const showQ17_5to6 = !data.ndmm && isNewEcrfA;

                        return (
                          <div
                            className="dependent-section"
                            key={`q17-${originalIndex}`}
                          >
                            <CollapsibleSectionHeader
                              title={
                                <>
                                  {data.lineOfTherapy
                                    ? `${data.lineOfTherapy}L – `
                                    : ""}
                                  {data.cohortTreatmentName}
                                  {data.cohortTreatmentNameSuperscript ==
                                  null ? (
                                    ""
                                  ) : (
                                    <>
                                      <sup className="supscript">
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          0,
                                          2,
                                        )}
                                      </sup>
                                      {data.cohortTreatmentNameSuperscript.slice(
                                        2,
                                      )}
                                    </>
                                  )}
                                </>
                              }
                              isExpanded={!isQ17BlockCollapsed(originalIndex)}
                              onToggle={() => toggleQ17Block(originalIndex)}
                              hasError={
                                !!(
                                  data.q17_1_hard_Err ||
                                  data.q17_2_hard_Err ||
                                  data.q17_3_hard_Err ||
                                  data.q17_4_hard_Err ||
                                  data.q17_5_hard_Err ||
                                  data.q17_6_hard_Err
                                )
                              }
                            />
                            <Collapse in={!isQ17BlockCollapsed(originalIndex)}>
                              <div>
                                <div className="question-bot-space">
                                  <div className="question question-weight">
                                    <span>Q17.</span>
                                    <span className="quest-text-pad">
                                      Please provide results for each disease
                                      assessment based on the records during the
                                      indicated window <u>prior to</u>{" "}
                                      initiation of{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {data.cohortTreatmentName}
                                        {data.cohortTreatmentNameSuperscript ==
                                        null ? (
                                          ""
                                        ) : (
                                          <>
                                            <sup className="supscript">
                                              {data.cohortTreatmentNameSuperscript.slice(
                                                0,
                                                2,
                                              )}
                                            </sup>
                                            {data.cohortTreatmentNameSuperscript.slice(
                                              2,
                                            )}
                                          </>
                                        )}
                                      </span>{" "}
                                      on{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {data.earliestCohortIndexDate}
                                      </span>
                                      .
                                    </span>
                                  </div>

                                  <div className="sub-question">
                                    <table
                                      style={{
                                        border: "1px solid black",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <tbody>
                                        {showQ17_1to4 && (
                                          <>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="sub-question-quest">
                                                  Q17.1.
                                                </span>
                                                <span className="quest-text-pad">
                                                  Lytic bone lesion assessment{" "}
                                                  <u>any time before</u> the
                                                  index date
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_1_${originalIndex}_present`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_1_${originalIndex}_present`}
                                                        name={`q17_1_${originalIndex}`}
                                                        value={1}
                                                        checked={
                                                          data.q17_1 === 1
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Present
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_1_${originalIndex}_absent`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_1_${originalIndex}_absent`}
                                                        name={`q17_1_${originalIndex}`}
                                                        value={2}
                                                        checked={
                                                          data.q17_1 === 2
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Absent
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_1_${originalIndex}_unknown`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_1_${originalIndex}_unknown`}
                                                        name={`q17_1_${originalIndex}`}
                                                        value={99}
                                                        checked={
                                                          data.q17_1 === 99
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Unknown or not assessed
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={data.q17_1_hard_Err}
                                                  message={
                                                    DiseaseHistErrorMsg.ProvideOptions
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="sub-question-quest">
                                                  Q17.2.
                                                </span>
                                                <span className="quest-text-pad">
                                                  Extramedullary disease
                                                  assessment{" "}
                                                  <u>any time before</u> the
                                                  index date
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_2_${originalIndex}_present`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_2_${originalIndex}_present`}
                                                        name={`q17_2_${originalIndex}`}
                                                        value={1}
                                                        checked={
                                                          data.q17_2 === 1
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Present
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_2_${originalIndex}_absent`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_2_${originalIndex}_absent`}
                                                        name={`q17_2_${originalIndex}`}
                                                        value={2}
                                                        checked={
                                                          data.q17_2 === 2
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Absent
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_2_${originalIndex}_unknown`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_2_${originalIndex}_unknown`}
                                                        name={`q17_2_${originalIndex}`}
                                                        value={99}
                                                        checked={
                                                          data.q17_2 === 99
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Unknown or not assessed
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={data.q17_2_hard_Err}
                                                  message={
                                                    DiseaseHistErrorMsg.ProvideOptions
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="sub-question-quest">
                                                  Q 17.3.
                                                </span>
                                                <span className="quest-text-pad">
                                                  Extramedullary or soft tissue
                                                  plasmacytoma assessment{" "}
                                                  <u>any time before</u> the
                                                  index date
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_3_${originalIndex}_present`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_3_${originalIndex}_present`}
                                                        name={`q17_3_${originalIndex}`}
                                                        value={1}
                                                        checked={
                                                          data.q17_3 === 1
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Present
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_3_${originalIndex}_absent`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_3_${originalIndex}_absent`}
                                                        name={`q17_3_${originalIndex}`}
                                                        value={2}
                                                        checked={
                                                          data.q17_3 === 2
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Absent
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_3_${originalIndex}_unknown`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_3_${originalIndex}_unknown`}
                                                        name={`q17_3_${originalIndex}`}
                                                        value={99}
                                                        checked={
                                                          data.q17_3 === 99
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Unknown or not assessed
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={data.q17_3_hard_Err}
                                                  message={
                                                    DiseaseHistErrorMsg.ProvideOptions
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="sub-question-quest">
                                                  Q 17.4.
                                                </span>
                                                <span className="quest-text-pad">
                                                  Paramedullary plasmacytoma
                                                  assessment{" "}
                                                  <u>any time before</u> the
                                                  index date
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_4_${originalIndex}_present`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_4_${originalIndex}_present`}
                                                        name={`q17_4_${originalIndex}`}
                                                        value={1}
                                                        checked={
                                                          data.q17_4 === 1
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Present
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_4_${originalIndex}_absent`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_4_${originalIndex}_absent`}
                                                        name={`q17_4_${originalIndex}`}
                                                        value={2}
                                                        checked={
                                                          data.q17_4 === 2
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Absent
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_4_${originalIndex}_unknown`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_4_${originalIndex}_unknown`}
                                                        name={`q17_4_${originalIndex}`}
                                                        value={99}
                                                        checked={
                                                          data.q17_4 === 99
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Unknown or not assessed
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={data.q17_4_hard_Err}
                                                  message={
                                                    DiseaseHistErrorMsg.ProvideOptions
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                        {showQ17_5to6 && (
                                          <>
                                            {/* Q17.5 */}
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="sub-question-quest">
                                                  Q17.5.A.
                                                </span>
                                                <span className="quest-text-pad">
                                                  Extramedullary disease
                                                  assessment within 3 months
                                                  prior to index (i.e., from{" "}
                                                  <span
                                                    style={{
                                                      color:
                                                        PageDesignConstants.fontColor,
                                                    }}
                                                  >
                                                    {data.cohortIndexDateMin91 ||
                                                      `[${data.cohortTreatmentName} index date - 91 days]`}
                                                  </span>{" "}
                                                  to{" "}
                                                  <span
                                                    style={{
                                                      color:
                                                        PageDesignConstants.fontColor,
                                                    }}
                                                  >
                                                    {data.earliestCohortIndexDate ||
                                                      `[${data.cohortTreatmentName} index date]`}
                                                  </span>
                                                  )
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_5_${originalIndex}_present`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_5_${originalIndex}_present`}
                                                        name={`q17_5_${originalIndex}`}
                                                        value={1}
                                                        checked={
                                                          data.q17_5 === 1
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Present
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_5_${originalIndex}_absent`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_5_${originalIndex}_absent`}
                                                        name={`q17_5_${originalIndex}`}
                                                        value={2}
                                                        checked={
                                                          data.q17_5 === 2
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Absent
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <div className="double-dig-answer">
                                                  <div className="option-without-input">
                                                    <label
                                                      htmlFor={`q17_5_${originalIndex}_unknown`}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={`q17_5_${originalIndex}_unknown`}
                                                        name={`q17_5_${originalIndex}`}
                                                        value={99}
                                                        checked={
                                                          data.q17_5 === 99
                                                        }
                                                        onChange={
                                                          HandleLotFieldChange
                                                        }
                                                      />
                                                      <span className="radio-text-padding">
                                                        Unknown or not assessed
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>
                                                <ErrorField
                                                  show={data.q17_5_hard_Err}
                                                  message={
                                                    DiseaseHistErrorMsg.ProvideOptions
                                                  }
                                                />
                                              </td>
                                            </tr>

                                            {/* Q17.6 - Only show if Q17.5 is "Present" (value 1) */}
                                            {data.q17_5 === 1 && (
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="sub-question-quest">
                                                    Q17.6.A.
                                                  </span>
                                                  <span className="quest-text-pad">
                                                    Did any extramedullary
                                                    disease assessments{" "}
                                                    <u>within 3 months prior</u>{" "}
                                                    to index have{" "}
                                                    <b>
                                                      <i>
                                                        central nervous system
                                                        involvement
                                                      </i>
                                                    </b>
                                                    ?
                                                  </span>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div className="double-dig-answer">
                                                    <div className="option-without-input">
                                                      <label
                                                        htmlFor={`q17_6_${originalIndex}_present`}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q17_6_${originalIndex}_present`}
                                                          name={`q17_6_${originalIndex}`}
                                                          value={1}
                                                          checked={
                                                            data.q17_6 === 1
                                                          }
                                                          onChange={
                                                            HandleLotFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Present
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div className="double-dig-answer">
                                                    <div className="option-without-input">
                                                      <label
                                                        htmlFor={`q17_6_${originalIndex}_absent`}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q17_6_${originalIndex}_absent`}
                                                          name={`q17_6_${originalIndex}`}
                                                          value={2}
                                                          checked={
                                                            data.q17_6 === 2
                                                          }
                                                          onChange={
                                                            HandleLotFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Absent
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div className="double-dig-answer">
                                                    <div className="option-without-input">
                                                      <label
                                                        htmlFor={`q17_6_${originalIndex}_unknown`}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q17_6_${originalIndex}_unknown`}
                                                          name={`q17_6_${originalIndex}`}
                                                          value={99}
                                                          checked={
                                                            data.q17_6 === 99
                                                          }
                                                          onChange={
                                                            HandleLotFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown or not
                                                          assessed
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <ErrorField
                                                    show={data.q17_6_hard_Err}
                                                    message={
                                                      DiseaseHistErrorMsg.ProvideOptions
                                                    }
                                                  />
                                                </td>
                                              </tr>
                                            )}
                                          </>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </Collapse>
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="survey-section-content-foot">
                  <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DiseaseHistory;
